var map = {
	"./charging_pick_icon.png": "f749",
	"./critical_icon.png": "b2a9",
	"./empty_icon.png": "a522",
	"./full_icon.png": "8a20",
	"./geo_fence_alert_icon.png": "6d6f",
	"./iot_fault_icon.png": "e2b2",
	"./is_charging_icon.png": "5c51",
	"./is_on_ride_icon.png": "a8ae",
	"./is_parking_icon.png": "3e38",
	"./is_reserved_icon.png": "5d02",
	"./low_battery_icon.png": "40d1",
	"./low_icon.png": "0c34",
	"./maintainance_icon.png": "0c9c",
	"./medium_icon.png": "2baf",
	"./missing_icon.png": "fde6",
	"./normal_icon.png": "6896",
	"./rebalance_icon.png": "5c89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81e4";